"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Act = void 0;
const lodash_1 = __importDefault(require("lodash"));
const polyline_1 = __importDefault(require("@mapbox/polyline"));
require("pixi.js");
const leaflet_1 = __importDefault(require("leaflet"));
require("./stravaApi");
class Act {
    constructor(data) {
        var _a;
        this.data = data;
        this.startDate = new Date(data.start_date);
        const polyline = (_a = data.map) === null || _a === void 0 ? void 0 : _a.summary_polyline;
        if (polyline) {
            let latLngs = polyline_1.default.decode(polyline); // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/48644
            if (latLngs.length > 2) {
                // filter jaggies
                const dist1 = lodash_1.default.range(latLngs.length - 1).map(i => Math.hypot(latLngs[i][0] - latLngs[i + 1][0], latLngs[i][1] - latLngs[i + 1][1]));
                const dist2 = lodash_1.default.range(latLngs.length - 2).map(i => Math.hypot(latLngs[i][0] - latLngs[i + 2][0], latLngs[i][1] - latLngs[i + 2][1]));
                for (let i = latLngs.length - 2; i >= 1; i--) {
                    const AB = dist1[i - 1];
                    const BC = dist1[i];
                    const AC = dist2[i - 1];
                    const excursion = AB + BC / 2;
                    if (AC < 0.3 * excursion) {
                        latLngs.splice(i, 1);
                    }
                }
            }
            this.latLngs = latLngs;
        }
    }
    applyProjection(project, getScaleFromProjected) {
        var _a;
        this.getScaleFromProj = getScaleFromProjected;
        this.projPoints = (_a = this.latLngs) === null || _a === void 0 ? void 0 : _a.map((pt) => project(pt));
        if (this.projPoints && this.projPoints.length > 0) {
            this.projBounds = leaflet_1.default.bounds(this.projPoints);
        }
    }
    // adapted from Leaflet/src/layer/vector/Polyline.js
    // p & tolerance are in in 'scale' pixels, unlike this.projX – you need to use this.getScaleFromProj(zoom)
    containsProjectedPoint(p, tol, zoom) {
        if (!this.projPoints || !this.projBounds || !this.getScaleFromProj) {
            return false;
        }
        const scale = this.getScaleFromProj(zoom);
        // This point is in the same coordinates as this.projX
        const projP = p.divideBy(scale);
        const projTol = tol / scale;
        if (!padBounds(this.projBounds, projTol).contains(projP)) {
            return false;
        }
        // hit detection for polylines
        const projectedPoints = this.projPoints; // they have xs & ys, which is enough for pointToSegmentDistance
        const l = projectedPoints.length - 1;
        for (let i = 0; i < l; i++) {
            if (leaflet_1.default.LineUtil.pointToSegmentDistance(projP, projectedPoints[i], projectedPoints[i + 1]) <= projTol) {
                return true;
            }
        }
        return false;
    }
}
exports.Act = Act;
function padBounds(bounds, padding) {
    return leaflet_1.default.bounds(bounds.min.subtract([padding, padding]), bounds.max.add([padding, padding]));
}
